import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";



class DialogDeleteScenario extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		;
		setTimeout(()=>{
			this.updateStatus({sent:null, message:''})
		}, 500);
	};

	handleSubmit(){

		
		this.updateStatus({sent:false, success:false, message:'Delete dialog...'});
		//saveguard for testing
	
		//console.log(setMainScenario);
		vindrApi.deleteDialog(this.props.setup.dialog.id).then((response)=>{
			if(response.success){
				this.updateStatus({sent:true, success:true, message:'The dialog was deleted'});
				
				if(response.success){
					
					if(this.props.onDelete)
						this.props.onDelete(this.props.setup.dialog.id);
					
				}
				
				
				setTimeout(()=>this.handleClose(), 2000);
				
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error delete dialog'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error delete dialog'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};

	handleOnShow(e){
		if(this.props.setup.prompt)
			return false;
		else
			this.handleSubmit();
		
	};

	render() {
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Delete dialog</Modal.Title>
				</Modal.Header>

				{this.state.status.sent === null ? (
					<React.Fragment>
						<Modal.Body>
							<Row className="">
								<Col xs="12" className="dialog-feedback-icon text-center">
									<i className="ri-error-warning-line text-warning" />
								</Col>
								<Col xs="12" className="dialog-feedback-text mb-5">
									You are about to delete a dialog.
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Button className="me-auto" variant="secondary" onClick={()=>{this.handleClose()}}>Close</Button>
							<Button onClick={()=>{this.handleSubmit()}} variant="success">Delete dialog</Button>
						</Modal.Footer>
					</React.Fragment>
				) : (
				<Modal.Body>
					<Row className="mb-3 dialog-feedback">
						<Col xs="12" className="dialog-feedback-icon text-center">
							{
							this.state.status.sent ?
								(this.state.status.success ? 
									(<i className="ri-checkbox-circle-line text-success"></i>)
									:
									(<i className="ri-error-warning-line text-warning"></i>)
								)
								:
								(<Spinner animation="border" variant="info" className="mt-5" />)
							}
						</Col>
						<Col xs="12" className="dialog-feedback-text mb-5">
							{this.state.status.message}
						</Col>
					</Row>
				</Modal.Body>	
				)}

			</Modal>
		);
	}
}

export default DialogDeleteScenario;